import { last } from "./last.js";

export const findLastIndex = <T>(
  arr: Array<T>,
  predicate: (value: T, index: number, obj: Array<T>) => boolean,
) => {
  const lastElement = last(
    arr
      .map((val, i): [number, T] => [i, val])
      .filter(([i, val]) => predicate(val, i, arr)),
  );
  return lastElement?.[0] ?? -1;
};
